import React  from "react";
import { useGLTF } from "@react-three/drei";

export function Mdr1W2S(props) {
  const { nodes, materials } = useGLTF("/new_models/mdr_1x2y.glb");
  return (
    <group {...props} dispose={null}>
      <mesh
        geometry={nodes.mdr_09_2S.geometry}
        material={materials["mdr_1.8_1S.002"]}
      />
    </group>
  );
}

useGLTF.preload("/new_models/mdr_1x2y.glb");

export default Mdr1W2S;
